import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UserFieldsService {

    private api_prefix: string;

    constructor(private http: HttpClient) {
        this.api_prefix = environment.backEndUrl + "/user_fields";
    }

    getUserFields(category_id: number): Observable<any> {
        let url = this.api_prefix + `/${category_id}`;
        return this.http.get(url);
    }
}
